// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3ifCp","header":"ClearentDisclaimer_header__3EpAH","inner":"ClearentDisclaimer_inner__W03Qn"};